
import React from 'react';
interface ExpanderState {
    display: boolean;
    // This state is only false for some components that wont work properly if the component is rendered but hidden
    // 6/27/2016 currently only used for the grid.
    displayed: boolean;
}

interface ExpanderProps extends React.PropsWithChildren<{}> {
    title: string;
    styles?: any;
    class?: string;
    initialDisplay?: boolean;
    setID?: string;
    onClick?: any;
    displayAction?: any;
    toggleOnce?: boolean;
    disableCreateElement?: boolean;
}

var expanderSet: any = {};

class Expander extends React.Component<ExpanderProps, ExpanderState> {
    actionToggled: boolean;
    constructor(props: ExpanderProps) {
        super(props);
        var displayed = !(this.props.disableCreateElement ? this.props.disableCreateElement : false);
        var display = this.props.initialDisplay ? true : false;
        this.actionToggled = false;
        this.state = { display: display, displayed: displayed || display };
    }

    expand = (expand: boolean) => {
        this.setState({ display: expand, displayed: expand || this.state.displayed });
    }

    private _toggle = () => {
        if (this.props.setID) {
            var expanders = expanderSet[this.props.setID];
            for (var i = 0; i < expanders.length; i++) {
                var expander = expanders[i];
                if (expander !== this) expander.state.display = false;

                expander.setState(expander.state);
            }
        } 
        if (this.props.onClick) this.props.onClick(!this.state.display);
        this.setState({ display: !this.state.display, displayed: !this.state.display || this.state.displayed });
    }

    componentDidMount() {
        if (this.props.setID) {
            if (expanderSet[this.props.setID]) {
                expanderSet[this.props.setID].push(this);
            } else {
                expanderSet[this.props.setID] = [this];
            }
        }
    }

    UNSAFE_componentWillUpdate(nextProps: ExpanderProps, nextState: ExpanderState) {
        if (nextState.display && this.props.displayAction && (!this.props.toggleOnce || !this.actionToggled)) {
            this.actionToggled = true;
            this.props.displayAction();
        }
    }

    componentWillUnmount() {
        if (this.props.setID) {
            expanderSet[this.props.setID] = undefined;
        }
    }

    render(): any {
        var isExpanderOpen: string = this.state.display ? 'active' : 'inactive';

        return (
            <div style={this.props.styles} className={`panel panel-default expander ${this.props.class}`}>
                <div className={`panel-heading ${isExpanderOpen}`} onClick={this._toggle}>
                    <div className={`panel-title exp-title ${isExpanderOpen}`}>
                        {this.props.title}
                    </div>
                </div>
                <div className={`exp-content ctnt-main ${isExpanderOpen}`}>
                    {this.state.display || this.state.displayed ? this.props.children : null}
                </div>
            </div>);
    }
}

export default Expander;